// inputs.js
import { validateRequired, validateDecimalWithLength, validateSelectInteger ,validateNotNull} from "../../../../helpers/validationsForm";

const Inputs = (id) => {
  // Verifica si es un modo de edición
  const isEditing = id > 0;
  return [
    {
      id: 1,
      label: "Código",
      name: "art_codigo",
      type: "int",
      value: "",
      placeholder: "Ingrese el código",
    },
    {
      id: 2,
      label: "Codigo de Barra",
      name: "art_codbarra",
      type: "int",
      value: "",
      placeholder: "Codigo de Barra",
    },
    {
      id: 3,
      label: "Descripción*",
      name: "art_descripcion",
      type: "text",
      value: "",
      placeholder: "Ingrese la descripción",
      validation: validateRequired,
    },
    {
      id: 4,
      label: "Descripción Detallada",
      name: "art_desclarga",
      type: "textarea",
      value: "",
      placeholder: "Descripción Detallada",
    },
    {
      id: 5,
      label: "Ramo*",
      name: "ramo_Id",
      type: "select",
      value: "",
      options: [],
      validation: (value, form) => {
        // Validación requerida
        const requiredError = validateNotNull(value);
        if (requiredError) {
          return requiredError;
        }

        // Validación de longitud
        const selectIntegerError = validateSelectInteger(value)
        if (selectIntegerError) {
          return selectIntegerError;
        }


        // Si no hay errores
        return null;
      }
    },
    {
      id: 6,
      label: "Rubro",
      name: "rubro_Id",
      type: "select",
      value: "",
      options: [],
    },
    {
      id: 7,
      label: "SubRubro ",
      name: "subrubro_Id",
      type: "select",
      value: "",
      options: [],
    },
    {
      id: 8,
      label: "Marca ",
      name: "marca_Id",
      type: "select",
      value: "",
      options: [],
    },

    {
      id: 9,
      label: "Articulo Fraccionable?",
      name: "art_fraccionable",
      type: "select",
      value: "",
      options: [
        { value: "1", label: 'No' },
        { value: "2", label: 'Si' },
      ],
      placeholder: "Fraccionable",
    },
    {
      id: 10,
      label: "Dias Garantia",
      name: "art_dias_garantia",
      type: "select",
      value: "",
      options: [
        { value: "0", label: '0 dias' },
        { value: "30", label: '30 dias' },
        { value: "45", label: '45 dias' },
        { value: "60", label: '60 dias' },
        { value: "90", label: '90 dias' },
        { value: "120", label: '6 meses' },
        { value: "1", label: '1 año' },
        { value: "2", label: '2 años' },
        { value: "3", label: '3 años' },
      ],
      placeholder: "Dias Garantia",
    },
    {
      id: 11,
      label: "Articulo Discontinuado?",
      name: "art_discontinuado",
      type: "select",
      value: "",
      options: [
        { value: "0", label: 'No' },
        { value: "1", label: 'Si' },
      ],
      placeholder: "Discontinuado",
    },
    {
      id: 12,
      label: "Articulo Destacado? ",
      name: "art_destacado",
      type: "select",
      value: "",
      options: [
        { value: false, label: 'No' },
        { value: true, label: 'Si' },
      ],
    },
    {
      id: 13,
      label: "Costo sin Impuesto",
      name: "art_ncostosinimpuesto",
      type: "float", // Tipo correcto para permitir decimales
      value: 0, // Valor inicial
      placeholder: "Costo sin Impuesto",

    },
    
    {
      id: 14,
      label: "Iva Cotizacion",
      name: "art_iva_cotizacion",
      type: "select",
      value: "",
      options: [
        { value: "1", label: '21 %' },
        { value: "2", label: '10.5 %' },
        { value: "3", label: '0 %' },
      ],
      placeholder: "Iva Cotizacion",
      enableSearch: false,
    },
    {
      id: 15,
      label: "Costo Con Impuesto",
      name: "art_ncostoconimpuesto",
      type: "float",
      value: 0,
      placeholder: "Costo Con Impuesto",
    },
    {
      id: 16,
      label: "Flete",
      name: "art_flete",
      type: "float",
      value: 0,
      placeholder: "Flete",
    },
    {
      id: 17,
      label: "Precio Costo*",
      name: "art_npreciocosto",
      type: "float", // Correcto para representar decimales
      value: 0, // Inicializado como 0
      placeholder: "Precio Costo", // Indicativo de lo que debe ingresar el usuario
      validation: (value, form) => {
        // Validación requerida
        const requiredError = validateNotNull(value);
        if (requiredError) {
          return requiredError; // Devuelve error si está vacío
        }
    
        // Validación de longitud y formato decimal
        const decimalWithLengthError = validateDecimalWithLength(value, { minLength: 1, maxLength: 10 });
        if (decimalWithLengthError) {
          return decimalWithLengthError; // Devuelve error si la longitud es inválida
        }
    
        // Validación específica para números flotantes
        if (!/^\d+(\.\d+)?$/.test(value)) { // Permite enteros y decimales
          return "Debe ser un número entero o decimal válido.";
        }
    
        // Si no hay errores, retorna null
        return null;
      },
    },
    {
      id: 18,
      label: "Iva Incluido",
      name: "art_ivaincluido",
      type: "select",
      value: "",
      options: [
        { value: "1", label: '21 %' },
        { value: "2", label: '10.5 %' },
        { value: "3", label: '0 %' },
      ],
      placeholder: "Iva Incluido",
    },
    {
      id: 19,
      label: "Precio Mayorista*",
      name: "art_npreciomayorista",
      type: "float",
      value: 0,
      placeholder: "Precio Mayorista",
      validation: (value, form) => {
        // Validación requerida
        const requiredError = validateNotNull(value);
        if (requiredError) {
          return requiredError;
        }

        // Validación de longitud
        const decimalWithLengthError = validateDecimalWithLength(value, { minLength: 1, maxLength: 10 })
        if (decimalWithLengthError) {
          return decimalWithLengthError;
        }


        // Si no hay errores
        return null;
      }
    },
    {
      id: 20,
      label: "Porc. Ganancia Mayorista",
      name: "porc_may",
      type: "float",
      value: 0,
      placeholder: "Porcentaje de Ganancia",
    },
    {
      id: 21,
      label: "Precio Minorista*",
      name: "art_nprecioventa",
      type: "float",
      value: 0,
      placeholder: "Precio Minorista",
      validation: (value, form) => {
        // Validación requerida
        const requiredError = validateNotNull(value);
        if (requiredError) {
          return requiredError;
        }

        // Validación de longitud
        const decimalWithLengthError = validateDecimalWithLength(value, { minLength: 1, maxLength: 10 })
        if (decimalWithLengthError) {
          return decimalWithLengthError;
        }


        // Si no hay errores
        return null;
      }
    },
    {
      id: 22,
      label: "Porc. Ganancia Minorista",
      name: "porc_min",
      type: "float",
      value: 0,
      placeholder: "Porcentaje de Ganancia",
    },
    {
      id: 23,
      label: "Porc. Rentas",
      name: "art_nporcrentas",
      type: "float",
      value: 0,
      placeholder: "Porc. Rentas",
    },
    {
      id: 24,
      label: "Porcentaje Facturación",
      name: "art_nporcentaje_facturacion",
      type: "float",
      value: 0,
      placeholder: "Porcentaje Facturación",
    },
    {
      id: 25,
      label: "Alquiler Porc",
      name: "art_alquiler_porc",
      type: "float",
      value: 0,
      placeholder: "Alquiler Porc",
    },
    {
      id: 26,
      label: "Precio Alquiler",
      name: "art_nprecioalquiler",
      type: "float",
      value: 0,
      placeholder: "Precio Alquiler",
    },
    {
      id: 27,
      label: "Articulo Combo? ",
      name: "art_es_combo",
      type: "select",
      value: 0,
      options: [
        { value: "0", label: 'No' },
        { value: "1", label: 'Si' },
      ],
      disable: isEditing,
    },
    {
      id: 28,
      label: "Imagen",
      name: "art_imagen",
      type: "file",
      value: "",
      placeholder: "Imagen",
    },
    {
      id: 29,
      label: "Articulo es WEB?",
      name: "art_esweb",
      type: "select",
      value: "",
      options: [
        { value: true, label: 'Si' },
        { value: false, label: 'No' },
      ],
    },
     {
      id: 30,
      label: "Mostrar en Web",
      name: "art_show_web",
      type: "select",
      value: "",
      options: [
        { value: 0, label: 'Si' },
        { value: 1, label: 'No' },
      ],
    },
     {
      id: 31,
      label: "Mostrar en App",
      name: "art_show_app",
      type: "select",
      value: "",
      options: [
        { value: 0, label: 'Si' },
        { value: 1, label: 'No' },
      ],
    }
  ];
};

export default Inputs;